var _filter, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeacherToolClick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    width: "1em",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 10.56,
    id: "80D33665-5831-4693-9E60-E1813BB3D5C7",
    width: 9.70669,
    x: 793.358,
    y: 353.166
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 1.36808,
    dy: 3.75877,
    floodColor: "#000000",
    height: 10.56,
    stdDeviation: 2.76635,
    width: 9.70669
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M610.851 28.144L610.851 28.144C666.901 28.144 712.34 71.0529 712.34 123.984L712.34 130.451C712.34 183.382 666.901 226.291 610.851 226.291L610.851 226.291C554.8 226.291 509.362 183.382 509.362 130.451L509.362 123.984C509.362 71.0529 554.8 28.144 610.851 28.144Z",
    fill: "#efefef",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.695 200.642C840.436 272.305 755.801 386.273 747.285 391.499C734.989 399.046 301.373 437.121 281.347 384.748C262.849 336.368 318.31 220.912 342.625 183.351C423.165 58.9358 815.51 67.9554 831.695 200.642Z",
    fill: "#6fa7ff",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.877 337.254C282.71 345.63 265.535 356.134 259.104 366.288C184.623 483.888 39.156 710.856 140.972 817.035C229.799 909.669 777.991 913.476 871.895 819.573C958.147 733.321 846.207 501.067 778.064 375.411C772.019 364.264 754.912 360.641 749.725 351.348C719.27 296.783 324.677 277.613 287.877 337.254Z",
    fill: "#ffe852",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.202 323.196C255.58 382.469 253.064 467.298 366.534 493.111C426.76 506.812 626.111 508.061 670.816 493.111C768.543 460.429 786.813 387.079 756.553 329.782C708.927 239.603 334.104 244.039 289.202 323.196Z",
    fill: "#693cff",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.228 317.857C294.323 358.164 290.283 414.224 386.411 433.404C436.576 443.412 601.332 443.737 638.957 433.404C726.982 409.229 735.231 361.299 710.116 322.335C670.588 261.011 359.496 264.028 322.228 317.857Z",
    fill: "#40288e",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798.211 358.02L798.211 358.02C798.368 358.02 798.496 358.147 798.496 358.304L798.496 358.588C798.496 358.746 798.368 358.873 798.211 358.873L798.211 358.873C798.054 358.873 797.927 358.746 797.927 358.588L797.927 358.304C797.927 358.147 798.054 358.02 798.211 358.02Z",
    fill: "#ffffff",
    filter: "url(#80D33665-5831-4693-9E60-E1813BB3D5C7)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.713 362.381L380.026 351.231C399.353 343.341 423.574 357.896 434.124 383.74L434.124 383.74C444.675 409.584 437.561 436.931 418.233 444.822L390.92 455.972C371.593 463.862 347.373 449.307 336.822 423.463L336.822 423.463C326.271 397.618 333.386 370.271 352.713 362.381Z",
    fill: "#6a6f6b",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.823 320.031L466.625 303.353C496.912 291.552 534.867 313.322 551.401 351.979L551.401 351.979C567.935 390.635 556.786 431.539 526.499 443.341L483.697 460.019C453.41 471.82 415.454 450.05 398.921 411.394L398.921 411.394C382.387 372.737 393.536 331.833 423.823 320.031Z",
    fill: "#f8a8b5",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.262 369.171L658.461 382.734C676.999 392.332 681.624 420.208 668.79 444.998L668.79 444.998C655.957 469.788 630.524 482.104 611.986 472.507L585.787 458.944C567.248 449.346 562.624 421.47 575.457 396.68L575.457 396.68C588.291 371.89 613.723 359.574 632.262 369.171Z",
    fill: "#7a7b7a",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.158 337.777L644.425 345.781C662.581 350.921 669.907 363.387 660.79 373.623L587.456 455.962C578.339 466.199 556.23 470.33 538.075 465.189L509.807 457.185C491.652 452.045 484.325 439.579 493.442 429.342L566.777 347.004C575.894 336.767 598.002 332.636 616.158 337.777Z",
    fill: "#c186fc",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.171 416.468C305.291 389.208 266.784 467.463 380.254 473.288C440.48 476.379 602.787 484.154 647.493 480.78C745.219 473.406 715.307 399.357 686.829 415.844C627.512 450.185 380.254 453.307 337.171 416.468Z",
    fill: "#693cff",
    opacity: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeacherToolClick);
export default __webpack_public_path__ + "static/media/TeacherToolClick.9f716241975adb1a898eee2c759437fb.svg";
export { ForwardRef as ReactComponent };